import { Button, Form, Modal } from "react-bootstrap";

import { DateTime } from "luxon";

import { dateFormatWeekday } from "../../../_helpers/dateHelper.ts";

const ModalPostponed = (props: any) => {
  const handleClose = () => {
    props.setShow(false);
  };

  const validate = () => {
    //Prepare data
    props.setIsPostponed(true);
    handleClose();
  };

  return (
    <Modal show={props.show} onHide={handleClose}>
      <div className="d-flex flex-column m-4">
        <div className="subTitleBoldConf">Prendre rendez-vous plus tard ?</div>
        <div className="mt-3 d-flex flex-column w-100">
          <div className="subTextConf">
            Vous n'êtes pas disponible le&nbsp;
            {(() => {
              try {
                return props.appointment?.startDate
                  ? DateTime.fromISO(props.appointment.startDate).toFormat(
                      dateFormatWeekday
                    )
                  : "jour prévu";
              } catch (e) {
                console.warn("Error formatting appointment date:", e);
                return "jour prévu";
              }
            })()}
            &nbsp;pour votre état des lieux ? Dans ce cas, réservez un créneau
            la journée suivante.
          </div>
        </div>
        <div className="mt-4 d-inline-flex">
          <div className="linkEmailConf">
            Veuillez en informer votre agence par écrit
          </div>
        </div>
        <Form.Check
          className="mt-4 subTextConf"
          type="checkbox"
          label={`Je confirme avoir pris connaissance des conditions.`}
        />
      </div>
      <div className="d-grid gap-2">
        <Button
          className="popupBtnConf"
          variant="primary"
          onClick={() => validate()}
        >
          Je décale le rendez-vous
        </Button>
      </div>
    </Modal>
  );
};

export default ModalPostponed;
